import { z } from 'zod';

export const sectoresSchema = z.object({
  eyebrow: z.string().max(120).optional(),
  title: z.string().min(1).max(200),
  titleHl: z.string().max(160).optional(),
  subtitle: z.string().max(500).optional(),
  metaStats: z
    .array(
      z.object({
        value: z.string().min(1).max(40),
        label: z.string().min(1).max(120),
      }),
    )
    .max(4)
    .optional(),
  sectors: z
    .array(
      z.object({
        slug: z.string().min(1).max(40),
        icon: z.string().min(1).max(8),
        name: z.string().min(1).max(80),
        count: z.string().max(8),
        label: z.string().max(160).optional(),
        title: z.string().min(1).max(200),
        description: z.string().max(600),
        ops: z.string().max(20),
        ticket: z.string().max(20),
        max: z.string().max(20),
        cases: z
          .array(
            z.object({
              tag: z.string().min(1).max(80),
              name: z.string().min(1).max(120),
              meta: z.string().max(160),
            }),
          )
          .min(1)
          .max(4),
      }),
    )
    .min(2)
    .max(20),
  ctaLabel: z.string().max(80).default('Ver casos del sector'),
  ctaHref: z.string().max(500).default('/portfolio'),
});

export type SectoresData = z.infer<typeof sectoresSchema>;
